jQuery(document).ready(function ($) {
	
	if ($('.play-btn').length > 0) {
		$('.play-btn').on('click', function() {
			var videoURL = $(this).data('video-url');
			if (typeof videoURL !== 'undefined') {
	
				$.magnificPopup.open({
					items: {
						src: '<div class="vid-wrap"><video poster="" style="width: 100%; height: auto;" controls autoplay><source src="'+videoURL+'" type="video/mp4" /></video></div>',
						type: "inline"
					},
					removalDelay: 300,
					mainClass: 'mfp-fade'
				});
	
			}
		});
	}
	
	});